import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { GamificationMainService } from '../../../services/gamification-main.service';

@Component({
  selector: 'cv-command-center-group-selector',
  templateUrl: './command-center-group-selector.component.html',
  styleUrls: ['./command-center-group-selector.component.scss']
})
export class CommandCenterGroupSelectorComponent implements OnInit {
  @ViewChild('selectorContainer') el: ElementRef;

  gms = null;

  constructor(
    private gamificationMainService: GamificationMainService
  ) { 
    this.gms = this.gamificationMainService.data;
  }

  ngOnInit(): void {
    this.gamificationMainService.loadGroupSelector().then(() => {    
      this.el.nativeElement.innerHTML = this.gms.groupSelectorHtml;
      
      const eventObj = {
        pageName: 'GamificationSettings*e'
      }

      $(document).trigger(new jQuery.Event('event_SelectedGroupsChanged', eventObj));
    });
  }
}